module.exports = __webpack_public_path__ + "media/images/product/bg2-84e08d409dac5ec1ddb7b976dcb95c17.png";